var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, useMemo, useState } from 'react';
import { ProgressBar } from '@cvent/carina-progress-indicator';
import { ChevronDownIcon, ChevronUpIcon } from '@cvent/carina-icon';
import useStyle from './MobileStepperStyles';
import usePercentageData from './PercentageData';
import StepperProgressBar from './StepperProgressBar';
import Step from './Step';
import CircularProgressBar from './CircularProgressBar';
import { getStepIndex } from '../utils/getStepIndex';
import { isFunction } from '@cvent/carina-utils';
/**
 * MobileStepper
 */
var MobileStepper = function (_a) {
    var currentStep = _a.currentStep, steps = _a.steps, isRtl = _a.isRtl, onStepSelection = _a.onStepSelection, generateLabel = _a.generateLabel, progressBarLabel = _a.progressBarLabel, showProgressBar = _a.showProgressBar, showStepNumbers = _a.showStepNumbers, _b = _a.strictNavigation, strictNavigation = _b === void 0 ? true : _b, propDrop = __rest(_a, ["currentStep", "steps", "isRtl", "onStepSelection", "generateLabel", "progressBarLabel", "showProgressBar", "showStepNumbers", "strictNavigation"]);
    var _c = __read(usePercentageData(steps), 2), stepCount = _c[0], lastCompletedIndex = _c[1];
    var getIndex = useMemo(function () {
        return getStepIndex(steps);
    }, [steps]);
    var currentStepIndex = useMemo(function () { return getIndex(currentStep.step); }, [
        currentStep,
        getIndex
    ]);
    var currentSubStepIndex = useMemo(function () {
        var _a;
        if (!((_a = steps[currentStepIndex]) === null || _a === void 0 ? void 0 : _a.subSteps)) {
            return 0;
        }
        return getStepIndex(steps[currentStepIndex].subSteps, currentStep.subStep);
    }, [steps, currentStep, currentStepIndex]);
    var _d = useStyle(isRtl), stepperWrapper = _d.stepperWrapper, mobileWrapper = _d.mobileWrapper, mobileStepWrapper = _d.mobileStepWrapper, mobileProgressBarWrapper = _d.mobileProgressBarWrapper, chevronWrapper = _d.chevronWrapper;
    var _e = __read(useState(false), 2), isExpanded = _e[0], setIsExpanded = _e[1];
    var render = function (shouldRender) {
        var subSteps = steps[currentStepIndex].subSteps;
        if (shouldRender) {
            var Icon = function (icon, title) {
                return (_jsxs(Fragment, { children: [!isExpanded && subSteps ? (_jsx(CircularProgressBar, __assign({ progress: (currentSubStepIndex / subSteps.length) * 100 }, { children: icon }), void 0)) : (_jsx(Fragment, { children: icon }, void 0)), title, _jsx("div", __assign({ css: chevronWrapper }, { children: isExpanded ? (_jsx(ChevronUpIcon, { size: "m", color: chevronWrapper.color }, void 0)) : (_jsx(ChevronDownIcon, { size: "m", color: chevronWrapper.color }, void 0)) }), void 0)] }, void 0));
            };
            return Icon;
        }
        return null;
    };
    if (!isExpanded) {
        var step = steps[currentStepIndex];
        return (_jsx("div", __assign({ css: mobileWrapper }, propDrop, { children: _jsxs("div", __assign({ css: mobileStepWrapper }, { children: [_jsx(Step, { name: step.name, status: step.status, isFirst: true, isLast: true, isCurrentStep: getIndex(currentStep.step) === getIndex(step.id) + 1, onClick: function () {
                            setIsExpanded(function (e) { return !e; });
                        }, generateLabel: generateLabel, showStepNumber: showStepNumbers, index: currentStepIndex + 1, subHeading: step.subHeading, isMobile: true, render: render(true), isRtl: isRtl }, step.name || step.id),
                    showProgressBar && (_jsx("div", __assign({ css: mobileProgressBarWrapper }, { children: _jsx(ProgressBar, { value: lastCompletedIndex, total: stepCount, size: "l" }, void 0) }), void 0))] }), void 0) }), void 0));
    }
    return (_jsxs("div", __assign({ css: stepperWrapper }, propDrop, { children: [steps.map(function (step, i) { return (_jsx(Step, { name: step.name, status: step.status, isFirst: i === 0, isLast: i === steps.length - 1, isCurrentStep: step.id === currentStep.step, onClick: function () {
                    if (i === 0) {
                        setIsExpanded(function (expanded) { return !expanded; });
                    }
                    else if (isFunction(onStepSelection)) {
                        onStepSelection(step, i);
                    }
                }, disabled: i !== 0 &&
                    ((strictNavigation && step.status === 'incomplete') ||
                        step.status === 'active'), showStepNumber: showStepNumbers, index: i + 1, subHeading: step.subHeading, subSteps: step.subSteps, currentSubStep: currentStep.subStep, isExpanded: isExpanded, render: render(i === 0), isRtl: isRtl }, step.id || step.name)); }),
            showProgressBar && (_jsx(StepperProgressBar, { isRtl: isRtl, steps: steps, label: progressBarLabel }, void 0))] }), void 0));
};
export default MobileStepper;
